<div class="container-fluid container-fluid-limited">
  <h1>{{ titre | translate }}</h1>
  <dsd-alert tabindex="-1" id="messageErreur" variant="inactive">
    <p *ngIf="estErreurSysteme" [innerHTML]="messageErreurSysteme | translate: { codeErreur: codeErreur }"></p>
    <p
      *ngIf="!estErreurSysteme"
      [innerHTML]="
        'caad.page-erreur-fiserv.messageErreurFonctionNonDisponible'
          | translate: { titre: titreTraduit, codeErreur: codeErreur }
      "></p>
  </dsd-alert>
</div>
<app-bouton-retour></app-bouton-retour>
